<template>
    <heads>
        <div class="flex space-x-4">
            <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg w-1/2">
                <loading :showLoading="form.processing"/>
                <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                    <p class="text-lg font-medium mb-4">Edit Role</p>
                    <form @submit.prevent="submitForm">
                        <div class="grid grid-cols-8 gap-4 mb-8">
                            <div class="col-span-8 sm:col-span-8">
                                <breeze-label :required="true" :value="'Name'"/>
                                <breeze-input required v-model="form.name" class="w-full"/>
                                <breeze-input-error :message="form.errors?form.errors.name:''"/>
                            </div>
                            <div class="col-span-8 sm:col-span-8">
                                <breeze-label :required="true" :value="'Level'"/>
                                <breeze-input type="number" required v-model="form.level" class="w-full"/>
                                <breeze-input-error :message="form.errors?form.errors.level:''"/>
                            </div>
                        </div>
                        <breeze-button :disabled="form.processing">Submit</breeze-button>
                        <span v-if="form.recentlySuccessful" class="text-green-500 mx-4">Role Updated!</span>
                        <exception/>
                    </form>
                </div>
            </div>
            <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg w-1/2">
                <loading :showLoading="permissionForm.processing"/>
                <div :class="{'opacity-50':permissionForm.processing,'opacity-100':!permissionForm.processing}">
                    <p class="text-lg font-medium mb-4">Create Permission</p>
                    <form @submit.prevent="submitPermissionForm">
                        <div class="grid grid-cols-8 gap-4 mb-8">
                            <div class="col-span-8 sm:col-span-8">
                                <breeze-label :required="true" :value="'Name'"/>
                                <breeze-input required v-model="permissionForm.name" class="w-full"/>
                                <breeze-input-error :message="permissionForm.errors?permissionForm.errors.name:''"/>
                            </div>
                        </div>
                        <breeze-button :disabled="permissionForm.processing">Submit</breeze-button>
                        <span v-if="permissionForm.recentlySuccessful"
                              class="text-green-500 mx-4">Permission Added!</span>
                        <exception/>
                    </form>
                </div>
            </div>
        </div>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg w-full mt-4 relative">
            <loading :showLoading="linkForm.processing"/>
            <div :class="{'opacity-50':linkForm.processing,'opacity-100':!linkForm.processing}">
                <p class="text-lg font-medium mb-4">Update Permissions to {{ userrole.name }}</p>
                <form @submit.prevent="submitLinkForm">
                    <div class="grid grid-cols-4 gap-4 mb-8" v-for="permissions,nindex in userpermissions"
                         :key="nindex">
                        <h2 class="col-span-4">{{ nindex }}</h2>
                        <div class="px-4 py-2 bg-gray-100 rounded-md"
                             :class="{'bg-gray-100':!permission.active,'bg-indigo-200':permission.active}"
                             v-for="permission,index in permissions" :key="index">
                            <div class="flex justify-between">
                                <breeze-label :value="permission.name"/>
                                <checkbox v-model="linkForm.permissions[nindex][index].active"
                                          :checked="linkForm.permissions[nindex][index].active"/>
                            </div>
                        </div>

                    </div>
                    <breeze-input-error class="mb-4" :message="linkForm.errors?linkForm.errors.permissions:''"/>
                    <breeze-button :disabled="linkForm.processing">Submit</breeze-button>
                    <span v-if="linkForm.recentlySuccessful" class="text-green-500 mx-4">Permission Updated!</span>
                    <exception/>
                </form>
            </div>
        </div>
    </heads>
</template>

<script>
import Heads from '@/Pages/Heads/Heads'
import BreezeInput from '@/Components/Input'
import BreezeLabel from '@/Components/Label'
import ButtonLink from '@/Components/ButtonLink'
import CardHeader from '@/Components/CardHeader'
import {useForm} from '@inertiajs/inertia-vue3'
import BreezeInputError from '@/Components/InputError'
import BreezeButton from '@/Components/Button'
import Checkbox from '@/Components/Checkbox'
import BreezeCheckbox from '@/Components/Checkbox'
import Loading from '@/Components/Loading'
import Exception from '@/Components/Exception'
import BreezeTable from '@/Components/Table'

export default {
    components: {
        Heads,
        BreezeInput,
        BreezeLabel,
        ButtonLink,
        CardHeader,
        BreezeInputError,
        BreezeButton,
        BreezeCheckbox,
        Loading,
        Exception,
        BreezeTable,
        Checkbox
    },
    props: ['userrole', 'userpermissions'],
    data() {
        return {
            form: useForm({
                '_method': 'PUT',
                name: this.userrole.name,
                level: this.userrole.level,
            }),
            permissionForm: useForm({
                name: '',
            }),
            linkForm: useForm({
                '_method': 'PUT',
                permissions: this.userpermissions,
            }),
        }
    },
    methods: {
        submitForm() {
            this.form.post(route('heads.role.update', this.userrole.id));
        },
        submitPermissionForm() {
            this.permissionForm.post(route('heads.permission.store', this.userrole.id), {
                preserveScroll: true,
                onSuccess: () => {
                    this.permissionForm.reset();
                    location.reload()
                },
            });
        },
        submitLinkForm() {
            this.linkForm.post(route('heads.role.updatePermissions', this.userrole.id), {
                preserveScroll: true,
                onSuccess: () => {
                    this.linkForm.reset();
                    location.reload()
                },
            });
        }
    }
}
</script>
